<template>
    <div class="main_container">
        <el-tabs type="border-card">
            <el-tab-pane label="撤除申请">
                <div class="view_mian">
                    <div class="title_sty">申请人基本信息</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="5">
                            <div class="grid-content bg-purple info_title">
                                <img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.RequesterName.LastCheckStatus==0?'showIcon':'hideIcon'">
                            <i class="i_style" :class="dataInfo.RequesterName.ifShowspan?'show_i':''">+</i>
                            <span class="no_span" :class="dataInfo.RequesterName.ifShowspan?'show_span':''" @click="unquailClick(dataInfo.RequesterName)">
                                申请人姓名：
                            </span>
                            </div>
                        </el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.RequesterName.NodeValue}}</div>
                        </el-col>
                    </el-row>
                     <el-row :gutter="10" class="info_item">
                        <el-col :span="5"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.RequesterPhoneNum.LastCheckStatus==0?'showIcon':'hideIcon'">

                        <i class="i_style" :class="dataInfo.RequesterPhoneNum.ifShowspan?'show_i':''">+</i><span class="no_span" :class="dataInfo.RequesterPhoneNum.ifShowspan?'show_span':''" @click="unquailClick(dataInfo.RequesterPhoneNum)">申请人电话：</span>
                        </div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.RequesterPhoneNum.NodeValue}}</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item" v-if="commitType == '2'">
                        <el-col :span="5"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.RequesterOrganisation.LastCheckStatus==0?'showIcon':'hideIcon'">

                         <i class="i_style" :class="dataInfo.RequesterOrganisation.ifShowspan?'show_i':''">+</i><span class="no_span" :class="dataInfo.RequesterOrganisation.ifShowspan?'show_span':''" @click="unquailClick(dataInfo.RequesterOrganisation)"> 所在单位：</span>
                        </div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.RequesterOrganisation.NodeValue}}</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item" v-if="commitType == '2'">
                        <el-col :span="5"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.PersonIdentification.LastCheckStatus==0?'showIcon':'hideIcon'">

                        <i class="i_style" :class="dataInfo.PersonIdentification.ifShowspan?'show_i':''">+</i><span class="no_span" :class="dataInfo.PersonIdentification.ifShowspan?'show_span':''" @click="unquailClick(dataInfo.PersonIdentification)"> 个人身份证明：</span>
                        </div></el-col>
                        <el-col :span="16">
                            <div class="grid-content bg-purple-light info_con" v-for="item in dataInfo.PersonIdentification.NodeValue" :key="item.index">
                                <!-- <div>{{item.FileName}}</div> -->
                                <div :id="'indexImg_'+item.FileGuid" :ref="'indexImg_'+item.FileGuid">
                                    <ul style="display:inline-block;">
                                        <li style="display:inline-block;" ><span>{{item.FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(item.FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid"></a></li>
                                    </ul>
                                    <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+item.FileGuid" download="个人身份证明" title="下载"  target="_blank" class="download_a">
                                    下载
                                    </a>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="title_sty">待撤文章信息</div>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="5"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.ArticleName.LastCheckStatus==0?'showIcon':'hideIcon'">

                         <i class="i_style" :class="dataInfo.ArticleName.ifShowspan?'show_i':''">+</i><span class="no_span" :class="dataInfo.ArticleName.ifShowspan?'show_span':''" @click="unquailClick(dataInfo.ArticleName)">题目名称：</span>
                        </div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.ArticleName.NodeValue}}</div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="5"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.Author.LastCheckStatus==0?'showIcon':'hideIcon'">

                         <i class="i_style" :class="dataInfo.Author.ifShowspan?'show_i':''">+</i><span class="no_span" :class="dataInfo.Author.ifShowspan?'show_span':''" @click="unquailClick(dataInfo.Author)">作者：</span>
                        </div></el-col>
                        <el-col :span="16"><div class="grid-content bg-purple-light info_con">{{dataInfo.Author.NodeValue}}</div></el-col>
                    </el-row>
                    
                     <el-row :gutter="10" class="info_item" v-if="commitType == '2'">
                        <el-col :span="5"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.UnitIdentification.LastCheckStatus==0?'showIcon':'hideIcon'">

                         <i class="i_style" :class="dataInfo.UnitIdentification.ifShowspan?'show_i':''">+</i><span class="no_span" :class="dataInfo.UnitIdentification.ifShowspan?'show_span':''" @click="unquailClick(dataInfo.UnitIdentification)">单位允许撤除证明：</span>
                        </div></el-col>
                        <el-col :span="19"><div class="grid-content bg-purple-light info_con">
                            <!-- {{dataInfo.UnitIdentification.NodeValue[0].FileName}} -->
                            <div :id="'indexImg_'+dataInfo.UnitIdentification.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.UnitIdentification.NodeValue[0].FileGuid">
                                <ul style="display:inline-block;">
                                    <li style="display:inline-block;" ><span>{{dataInfo.UnitIdentification.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.UnitIdentification.NodeValue[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.UnitIdentification.NodeValue[0].FileGuid"></a></li>
                                </ul>

                                <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.UnitIdentification.NodeValue[0].FileGuid" download="单位允许撤除证明" title="下载"  target="_blank" class="download_a">
                                下载
                                </a>
                            </div>
                            </div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="5"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.CheckReport.LastCheckStatus==0?'showIcon':'hideIcon'">

                         <i class="i_style" :class="dataInfo.CheckReport.ifShowspan?'show_i':''">+</i><span class="no_span" :class="dataInfo.CheckReport.ifShowspan?'show_span':''" @click="unquailClick(dataInfo.CheckReport)">检测报告单：</span>
                        </div></el-col>
                        <el-col :span="19"><div class="grid-content bg-purple-light info_con">
                            <!-- {{dataInfo.CheckReport.NodeValue[0].FileName}} -->
                            <div :id="'indexImg_'+dataInfo.CheckReport.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.CheckReport.NodeValue[0].FileGuid">
                                <ul style="display:inline-block;">
                                    <li style="display:inline-block;" ><span>{{dataInfo.CheckReport.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.CheckReport.NodeValue[0].FileGuid,'pdf')">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.CheckReport.NodeValue[0].FileGuid"></a></li>
                                </ul>

                                <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.CheckReport.NodeValue[0].FileGuid" download="检测报告单" title="下载"  target="_blank" class="download_a">
                                下载
                                </a>
                            </div>
                            </div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="5"><div class="grid-content bg-purple info_title"><img :src="imgUrl" alt="" class="warn_icon" :class="dataInfo.ArticleLocation.LastCheckStatus==0?'showIcon':'hideIcon'">

                         <i class="i_style" :class="dataInfo.ArticleLocation.ifShowspan?'show_i':''">+</i><span class="no_span" :class="dataInfo.ArticleLocation.ifShowspan?'show_span':''" @click="unquailClick(dataInfo.ArticleLocation)">待撤文章位置：</span>
                        </div></el-col>
                        <el-col :span="19"><div class="grid-content bg-purple-light info_con">
                            <!-- {{dataInfo.ArticleLocation.NodeValue[0].FileName}} -->
                            <div :id="'indexImg_'+dataInfo.ArticleLocation.NodeValue[0].FileGuid" :ref="'indexImg_'+dataInfo.ArticleLocation.NodeValue[0].FileGuid">
                                <ul style="display:inline-block;">
                                    <li style="display:inline-block;" ><span>{{dataInfo.ArticleLocation.NodeValue[0].FileName}}</span><a class="view_a" target="_blank" id="test" @click="showImgFn(dataInfo.ArticleLocation.NodeValue[0].FileGuid)">查看<img xss=removed  :data-original="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.ArticleLocation.NodeValue[0].FileGuid"></a></li>
                                </ul>

                                <a :href="authImgUrl+'/api/Common/GetOriginalFile?BatchID='+dataInfo.ArticleLocation.NodeValue[0].FileGuid" download="待撤文章位置" title="下载"  target="_blank" class="download_a">
                                下载
                                </a>
                            </div>
                            </div></el-col>
                    </el-row>
                    <el-row :gutter="10" class="info_item">
                        <el-col :span="5"><div class="grid-content bg-purple info_title">申请提交时间：</div></el-col>
                        <el-col :span="19"><div class="grid-content bg-purple-light info_con">{{dataInfo.CreateTime}}</div></el-col>
                    </el-row>
                    <div class="shenhe_box" v-show="ifShenHe">
                        <div class="title_sty">审核意见</div>
                        <el-row :gutter="10" class="info_item">
                            <el-col :span="5"><div class="grid-content bg-purple info_title">审核结果：</div></el-col>
                            <el-col :span="19">
                                <!-- <div class="grid-content bg-purple-light info_con">{{dataInfo.CheckStatusText}}</div> -->
                                <el-select v-model="RequestReviewDto.Result" placeholder="请选择" style="width:400px !important;">
                                    <el-option
                                    style="width:400px;"
                                    v-for="item in options2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                    :disabled="item.disabled">
                                    </el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                        <el-row :gutter="10" class="info_item">
                            <el-col :span="5"><div class="grid-content bg-purple info_title">审核意见：</div></el-col>
                            <el-col :span="19">
                                <!-- <div class="grid-content bg-purple-light info_con">{{dataInfo.Comment}}</div> -->
                                <el-input
                                style="width:400px;font-size:12px;"
                                type="textarea"
                                :rows="2"
                                placeholder="请输入内容"
                                :autosize="{ minRows: 5}"
                                v-model="addCommet">
                                </el-input>
                                <div v-if="commitType == '2'">
                                    <ul class="checkBox_box" v-for="(item,index) in optionCommit" :key="item.id">
                                        <li
                                            class="checkBox_item"
                                            @click="adDCommit(item.commitItem,index,item)"
                                            :class="item.ifClick?'show_color'+item.id:'hide_color'+item.id"
                                        >
                                            {{item.commitItem}}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>
                                    <ul class="checkBox_box" v-for="(item,index) in optionCommit1" :key="item.id">
                                        <li
                                            class="checkBox_item"
                                            @click="adDCommit(item.commitItem,index,item)"
                                            :class="item.ifClick?'show_color'+item.id:'hide_color'+item.id"
                                        >
                                            {{item.commitItem}}
                                        </li>
                                    </ul>
                                </div>
                            </el-col>
                        </el-row>
                        <div class="btn_box">
                            <el-button type="primary" :loading="loading" class="reApply_btn backRecord_btn" @click="commitReviewFn">确认提交</el-button>
                            <el-button type="primary"  class="backRecord_btn" @click="backRecord">返回待审核列表</el-button>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import Viewer from 'viewerjs';
import 'viewerjs/dist/viewer.css';
export default {
    data(){
        return{
            authImgUrl:BASE_URL,
            options2:[
                {
                value: '0',
                label: '不通过'
                },
                {
                value: '1',
                label: '通过'
                }
            ],
            ifShowspan:true,
            addCommet:"",
            optionCommit:[
                //"“个人身份证明”不符合要求;","“单位允许撤除证明”不符合要求;","“检测报告单”不符合要求;","“待撤文章位置”不符合要求;"
                {
                    id:0,
                    commitItem:"“个人身份证明”不符合要求  ",
                    ifClick:false
                },
                {
                    id:1,
                    commitItem:"“单位允许撤除证明”不符合要求  ",
                    ifClick:false
                },
                {
                    id:2,
                    commitItem:"“检测报告单”不符合要求  ",
                    ifClick:false
                },
                {
                    id:3,
                    commitItem:"“待撤文章位置”不符合要求  ",
                    ifClick:false
                },
            ],
            optionCommit1: [
                {
                    id:2,
                    commitItem:"“检测报告单”不符合要求  ",
                    ifClick:false
                },
                {
                    id:3,
                    commitItem:"“待撤文章位置”不符合要求  ",
                    ifClick:false
                },
            ],
            optionCommiStr:"",
            value2:"",
            RequestReviewDto:{
                "RequestID": null,
                "Result": null,
                "Comment": "",
                "ErrorList": []
            },
            ifShenHe:true,
            imgUrl:require("../../assets/images/yellow_warn_icon1.png"),
            //imgUrl:"",
            showWran:true,
            paramsData:{
                requestID:"",
                Comment: "",
                UpdateTime: ""
            },
            dataInfo:{
                RequesterName:{
                    NodeValue:""
                },
                RequesterPhoneNum:{
                    NodeValue:""
                },
                RequesterOrganisation:{
                    NodeValue:""
                },
                PersonIdentification:{
                    NodeValue:""
                },
                ArticleName:{
                    NodeValue:""
                },
                Author:{
                    NodeValue:""
                },
                Publication:{
                    NodeValue:""
                },
                PublishTime:{
                    NodeValue:""
                },
                UnitIdentification:{
                    NodeValue:[{FileName:""}]
                },
                CheckReport:{
                    NodeValue:[{FileName:""}]
                },
                ArticleLocation:{
                    NodeValue:[{FileName:""}]
                },
                CreateTime:"",
            },
            commitType: "",
            loading: false
        }
    },
    methods:{
        showImgFn(FileGuid,Clicktype){
            if(Clicktype){
                var url = this.authImgUrl+'/api/Common/GetOriginalFile?BatchID='+FileGuid;
                window.open( location.origin+location.pathname+'static/pdf/web/viewer.html?file=' + encodeURIComponent(url))
                return false;
            }
            var _this = this;
            // console.log("_this[FileGuid]=====",_this[FileGuid]);
            var ViewerDom = document.getElementById('indexImg_'+FileGuid);
            // console.log("ViewerDom===",ViewerDom)
            // debugger
            if(!_this[FileGuid]){
                _this[FileGuid] = new Viewer(document.getElementById('indexImg_'+FileGuid), {
                // 相关配置项,详情见下面
                inline: false,  //是否启用 inline 模式
                url: 'data-original',  //设置大图片的 url
                navbar: false,  //显示缩略图导航
                zoomRatio: 0.4,  //鼠标滚动时的缩放比例
                // minZoomRatio:0.01, //最小缩放比例
                // maxZoomRatio:100, //最大缩放比例
                // zIndex:2015, //设置图片查看器 modal 模式时的 z-index
                button: true,  //显示右上角关闭按钮（jQuery 版本无效）
                title: true,  //显示当前图片的标题（现实 alt 属性及图片尺寸）
                keyboard: true,  //是否支持键盘
                movable: true,  //图片是否可移动
                tooltip: true,  //显示缩放百分比
                // rotatable: true,  //图片是否可旋转
                // scalable: true,  //图片是否可翻转
                toolbar: {   //显示工具栏
                    zoomIn: 1,
                    zoomOut: 1,
                    oneToOne: 1,
                    reset: 1,
                    prev: 0,
                    play: 0,
                    next: 0,
                    rotateLeft: 1,
                    rotateRight: 1,
                    flipHorizontal: 1,
                    flipVertical: 1,
                },
                viewed: function () {
                    _this[FileGuid].view(0);
                }
            });
            }

            _this[FileGuid].show();

        },
        commitReviewFn(){
            var _this = this;
            _this.loading = true
            _this.RequestReviewDto.Comment = _this.optionCommiStr+_this.addCommet;
            // debugger
            if(_this.RequestReviewDto.Result==null||_this.RequestReviewDto.Result==undefined){
                _this.loading = false
                this.$message({
                    message: "请选择审核结果",
                    type: 'error',
                    duration: 5 * 1000
                })
                return false;
            }
            _this.RequestReviewFn(_this.RequestReviewDto);
        },
        RequestReviewFn(RequestReviewDto){
            // this.paramsData.Comment=this.RequestReviewDto.Comment
            // this.paramsData.UpdateTime=this.dataInfo.CreateTime
            var _this = this;
            _this.$api.RequestReview(RequestReviewDto).then(res => {
                try {
                    if(res.data.result){
                       
                        this.$message({
                            message:"提交成功！",
                            type: 'success',
                            duration: 5 * 1000
                        })
                        this.$router.push('/checkedList');
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error',
                            duration: 5 * 1000
                        })
                    }
                } catch (error) {
                    _this.loading = false
                    console.log(error)
                } finally {
                    _this.loading = false
                }
                // if(res.data.result){
                //     _this.loading = false
                //     this.$message({
                //         message:"提交成功！",
                //         type: 'success',
                //         duration: 5 * 1000
                //     })
                //     this.$router.push('/checkedList');
                // }else{
                //     _this.loading = false
                //     this.$message({
                //         message: res.data.message,
                //         type: 'error',
                //         duration: 5 * 1000
                //     })
                // }
                // _this.loading = false
            })
        },
        unquailClick(titleCon){
            var _this = this;
            if(titleCon.ifShowspan){//取消不合格
                _this.RequestReviewDto.ErrorList.forEach((item,index) =>{
                    if(item.ID==titleCon.ID){
                        _this.RequestReviewDto.ErrorList.splice(index,1);
                    }
                })
            }else{
                _this.RequestReviewDto.ErrorList.push({
                    ID:titleCon.ID
                });
            }
            titleCon.ifShowspan=!titleCon.ifShowspan;
            console.log(_this.RequestReviewDto.ErrorList)
        },
        adDCommit(itemCommit,index,item){
            var _this = this;
            // if(_this.optionCommiStr.indexOf(itemCommit)!=-1){
            //     _this.optionCommiStr=_this.optionCommiStr.replace(itemCommit,"");
            //     item.ifClick=false;
            // }else{
            //     _this.optionCommiStr+=itemCommit;
            //     item.ifClick=true;
            //     return false;
            // }
            item.ifClick=true;
            _this.addCommet+=itemCommit;

        },
        backRecord(){
            var _this = this;
            _this.$router.push("/waitVerify");
        },
        reApply(){
            var _this = this;
            _this.$router.push("/applyIndex");
        },
        detailGetBysearchParam(request){
            // console.log('request', request)
            var _this = this;
            _this.$api.detailGetBysearchParam(request).then(res => {
                if(res.data.result){
                    // console.log(res)
                    var dataList=res.data.info;
                    if(dataList.CheckStatus==0){
                        _this.ifShenhe = false;
                    }
                    //console.log("dataList=====",dataList);
                    for(var key in dataList){
                       if(dataList[key]&&typeof(dataList[key])=="object"){
                        //    console.log("dataList[key]",dataList[key])
                           dataList[key].ifShowspan=false;
                       }
                    }
                    _this.dataInfo = dataList;
                    // console.log('_this.dataInfo', _this.dataInfo)
                }else{
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
            })
        }
    },
    mounted(){
        if(this.$route.params.id){
            this.paramsData.requestID=this.$route.params.id
            this.commitType=this.$route.params.type
            this.RequestReviewDto.RequestID = this.$route.params.id
            this.paramsData.Comment=this.$route.params.row.Comment
            this.paramsData.UpdateTime=this.$route.params.row.UpdateTime
        }
        // console.log('requestID', this.paramsData)
        this.detailGetBysearchParam(this.paramsData);
    }

}
</script>

<style  scoped>
.view_mian{
    padding:30px 50px
}
.info_item{
    line-height: 40px;
    font-size: 14px;
    color:#606266;
}
.info_title{
    text-align: right;
}
.btn_box{
    margin-left:28%;
}
.reApply_btn{
    padding: 5px 10px;
    margin-bottom: 15px;
    margin-left: 112px;
 }
 .backRecord_btn{
     padding:8px 10px;
 }
 .warn_icon{
     /* margin-right:5px; */
     /* vertical-align: middle; */
 }
 .checkBox_box{

 }
 .checkBox_item{
    background: #c0c4cc;
    max-width: 206px;
    /* height: 30px; */
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    border-radius: 10px;
    margin-top:5px;
    font-size: 12px;
 }
 .checkBox_item:hover{
     background:#909399;
     color:#fff;
 }
 .show_color0, .show_color1, .show_color2, .show_color3{
     background: #0184BA;
     color:#fff;
 }
 .hide_color0,.hide_color1,.hide_color2,.hide_color3{
    background: #c0c4cc;
    /* color:#fff; */
 }
 .no_span{
    /* background: #f85959; */
    border-radius: 5px;
    /* color: #fff; */
    /* line-height: 55px; */
    display: inline-block;
    line-height: 25px;
    cursor: pointer;
    padding-left: 3px;
 }
 .show_span{
     background: #f85959;
     color: #fff;
 }
 .i_style{
    transform:rotate(45deg) ;
    -ms-transform:rotate(45deg) ;
    -webkit-transform:rotate(45deg) ;
    -o-transform:rotate(45deg);
    -moz-transform:rotate(45deg);
    display:inline-block;
    font-size: 25px;
    color:#f85959;
    font-weight: bold;
    display:none;
 }
 .show_i{
     display: inline-block;
 }
</style>



// WEBPACK FOOTER //
// viewInfo.vue?60f79e6d